export const DefaultMultiAttributionLookbackDays = 30;
export const MinMultiAttributionLookbackDays = 1;
export const MaxMultiAttributionLookbackDays = 90;
